<script>
export default {
  data: () => ({
    active: 0,
  }),

  computed: {
    exect () {
      return this.active === 1;
    },

    open () {
      return this.active === 0;
    },
  },
};
</script>

<template>
  <article class="card transaction-my-order transaction-table">
    <header class="card__header">
      <h2 class="card__title transaction-table__title">Minhas Ordens</h2>

      <RouterLink
        to="/financeiro/ordens"
        class="transaction-my-order__link"
        >
        Mais Detalhes
      </RouterLink>
    </header>

    <div class="transaction-my-order__body">
      <div class="transaction-my-order__actions">
        <button
          @click.prevent="active = 0"
          class="transaction-my-order__action"
          :class="{ 'transaction-my-order__action--active': active === 0 }"
        >
          Abertas
        </button>

        <button
          @click.prevent="active = 1"
          class="transaction-my-order__action"
          :class="{ 'transaction-my-order__action--active': active === 1 }"
        >
          Executadas
        </button>
      </div>

      <table>
        <thead>
          <tr>
            <th v-if="exect">Ordem</th>
            <th>Data</th>
            <th>Tipo</th>
            <th>Quantidade</th>
            <th>Executada</th>
            <th>Preço</th>
            <th v-if="open">Ação</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td v-if="exect">
              <span class="transaction-my-order__type">C</span>
            </td>
            <td>02/05/19</td>
            <td>Limitada</td>
            <td>300</td>
            <td v-if="open">182</td>
            <td v-if="exect">
              <span class="transaction-my-order__percent">
                182 <span>(98%)</span>

                <span class="transaction-my-order__percent-bar" style="width: 98%"></span>
              </span>
            </td>
            <td>R$ 20.000,00</td>
            <td v-if="open">
              <button
                class="transaction-my-order__cancel"
                >
                Cancelar
              </button>
            </td>
          </tr>
          <tr>
            <td v-if="exect">
              <span class="transaction-my-order__type">C</span>
            </td>
            <td>02/05/19</td>
            <td>Limitada</td>
            <td>300</td>
            <td v-if="open">182</td>
            <td v-if="exect">
              <span class="transaction-my-order__percent">
                78 <span>(99%)</span>

                <span class="transaction-my-order__percent-bar" style="width: 99%"></span>
              </span>
            </td>
            <td>R$ 20.000,00</td>
            <td v-if="open">
              <button
                class="transaction-my-order__cancel"
                >
                Cancelar
              </button>
            </td>
          </tr>
          <tr>
            <td v-if="exect">
              <span class="transaction-my-order__type transaction-my-order__type--sell">V</span>
            </td>
            <td>02/05/19</td>
            <td>Limitada</td>
            <td>300</td>
            <td v-if="open">182</td>
            <td v-if="exect">
              <span class="transaction-my-order__percent">
                97 <span>(66%)</span>

                <span class="transaction-my-order__percent-bar transaction-my-order__percent-bar--sell" style="width: 66%"></span>
              </span>
            </td>
            <td>R$ 20.000,00</td>
            <td v-if="open">
              <button
                class="transaction-my-order__cancel"
                >
                Cancelar
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </article>
</template>

<style lang="scss">
  .transaction-my-order {
    .card__header {
      justify-content: space-between;
    }

    .card__title {
      margin: 0;
    }

    table {
      font-size: 12px;
    }

    th {
      // override default style
      // use important here cause I don't wanna nest too much
      width: 16% !important;
    }

    &__body {
      padding: 16px 24px;
    }

    &__actions {
      margin-bottom: 24px;

      :not(:last-child) {
        margin-right: 16px;
      }
    }

    &__action {
      line-height: 1;
      font-size: 13px;
      transition: 150ms;
      margin-left: auto;
      padding: 12px 26px;
      border-radius: 4px;
      letter-spacing: .26px;
      color: rgba(#FFF, .8);
      border: 1px solid #FFF;

      &:hover {
        background-color: rgba(#FFF, .1);
      }

      &--active {
        border-color: #3e388b;
        color: rgba(#FFF, .95);
        background-color: #3e388b !important;
      }
    }

    &__type {
      width: 18px;
      height: 18px;
      color: #FFF;
      display: flex;
      line-height: 1;
      font-size: 10px;
      border-radius: 50%;
      align-items: center;
      justify-content: center;
      background-color: #509e02;

      &--sell {
        background-color: #d0021b;
      }
    }

    &__percent {
      position: relative;

      span {
        font-size: 10px;
        font-weight: 300;
        line-height: 1.2;
        color: #b2b8c5;
      }

      &-bar {
        left: 0;
        bottom: -3px;
        position: absolute;
        border-bottom: 2px solid #60c100;

        &--sell {
          border-color: #ff001f;
        }
      }
    }

    &__link,
    &__cancel {
      font-size: 13px;
      color: rgba(#FFF, .8);
      letter-spacing: .26px;
    }

    &__cancel {
      padding: 4px 8px;
      transition: 150ms;
      border-radius: 4px;
      border: 1px solid #FFF;

      &:hover {
        background-color: rgba(#FFF, .1);
      }
    }
  }
</style>
